import { render, staticRenderFns } from "./challange.vue?vue&type=template&id=2360160d&"
import script from "./challange.vue?vue&type=script&lang=js&"
export * from "./challange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports